module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/cleaning-mobile@2x-e3826fd760d80c32316d7eddfefd0062.jpg";